<template>
  <v-dialog v-model="showModal">
    <v-card
      outlined
      color="#ECEFF1"
    >
      <v-card-title>
        <p class="text-style">
          Suggest a new date for this task
        </p>
      </v-card-title>
      <v-card-text>
        <v-datetime-picker
          v-model="fromDate"
          date-format="yyyy-MM-dd"
          label="Select a Date and Time*"
          time-format="HH:mm:ss"
          :dialog-width="300"
          :text-field-props="{
            light: light,
            backgroundColor: '#FFF',
            outlined: outlined,
            dense: dense,
            hint: 'Please specify the time as well.',
            persistentHint: true,
            suffix: userTimeZone,
            class: 'field-text-style',
            rules: [(v) => !!v || 'Check-out Time is required'],
          }"
          :date-picker-props="{
            headerColor: 'black',
            light: true,
            min: minDate,
          }"
          :time-picker-props="{
            headerColor: 'black',
            light: true,
          }"
        >
          <template #dateIcon>
            <v-icon
              large
              color="white"
            >
              mdi-calendar
            </v-icon>
          </template>
          <template #timeIcon>
            <v-icon
              color="white"
              large
            >
              mdi-alarm
            </v-icon>
          </template>
        </v-datetime-picker>
        <br>
        <div>
          <v-btn
            class="accept-style"
            elevation="0"
            color="#64CA7F"
            @click="next()"
          >
            Suggest
          </v-btn>&nbsp;&nbsp;
          <v-btn
            class="suggest-style"
            elevation="0"
            color="#D9D9D9"
            @click="showModal = false"
          >
            Cancel
          </v-btn>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from 'moment';
import { getTimeZone } from '../../../../../utils/timezone';
export default {
  name: 'SuggestJobDateDialog',
  props: {
    jobRequestDetails: {
      type: Object,
      default: null,
    },
  },
  data: () => ({
    showModal: true,
    minDate: moment().format('YYYY-MM-DD'),
    fromDate: moment().format('YYYY-MM-DD HH:mm:ss'),
    light: true,
    outlined: true,
    dense: true,
  }),
  computed: {
    userTimeZone () {
      const timezone = getTimeZone();
      return timezone;
    },
  },
  watch: {
    showModal: function (newval, oldval) {
      if (newval === false) {
        this.$emit('closed');
      }
    },
  },
  methods: {
    next () {
      this.showModal = false;
      this.$emit('suggested', this.fromDate);
    },
  },
};
</script>

<style scoped>
.text-style {
  color: #5dad54;
  font-weight: 400;
}

.accept-style,
.suggest-style {
  height: 30px !important;
  font-size: 12px;
  padding: 0px 15px !important;
  font-weight: lighter !important;
  text-transform: none !important;
  color: #37474F;
}
</style>
